import React from 'react';
import {
  Button,
  Box,
  Divider,
  Stack,
  useWindowProperties,
  Body,
} from '@qred/components-library';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import useTranslate from '~/hooks/useTranslate';
import { ApiStatus } from '~/store/types/sharedTypes';
import { RootState } from '~/store';
import useCardConsentText from '~/hooks/useCardConsentText';
import { sendSignersCardOfferData } from '~/store/actions/additionalSignerActions';

export const CardAdditionalSignerFooter = () => {
  const dispatch = useAppDispatch();

  const {
    additionalSigner: {
      apiStatus: { postAdditionalSignerCardApplication },
    },
  } = useSelector((state: RootState) => state);
  const translate = useTranslate();
  const { isMobile } = useWindowProperties();
  const cardConsentText = useCardConsentText();

  const onConfirmClick = () => {
    dispatch(sendSignersCardOfferData());
  };

  return (
    <Box>
      <Divider thickness={1} color="neutral.16" />
      <Stack spacing={'md'} align="center" p={isMobile ? 'md' : 'xxl'}>
        <Body size="sm">{cardConsentText}</Body>
        <Button
          fullWidth={isMobile}
          onClick={onConfirmClick}
          size="md"
          isLoading={postAdditionalSignerCardApplication === ApiStatus.Started}
        >
          {translate('ConfirmTermsCard.ConfirmAgreement')}
        </Button>
      </Stack>
    </Box>
  );
};
